import { useMemo } from 'react';
// import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid';
import CustomTablePaginationAction from './CustomTablePaginationAction';

const DataGridPaginationAction = ({ showAllHref, ...rest }) => {
  const { page, rowsPerPage, count, onPageChange } = rest;
  // const apiRef = useGridApiContext();
  // const rootProps = useGridRootProps();
  const totalPages = useMemo(
    () => (rowsPerPage > 0 ? Math.ceil(count / rowsPerPage) : 0),
    [count, rowsPerPage],
  );

  const canPrev = page > 0;
  const canNext = totalPages === 0 ? false : page < totalPages - 1;
  // const defaultPageSize =
  //   rootProps.initialState?.pagination?.paginationModel?.pageSize || rowsPerPage;

  // const isShowingAll = useMemo(() => rowsPerPage === count, [rowsPerPage, count]);

  return (
    <>
      <CustomTablePaginationAction
        // page navigation → let the grid update paginationModel and trigger your fetch
        onNextClick={() => {
          if (canNext) onPageChange?.(null, page + 1);
        }}
        onPrevClick={() => {
          if (canPrev) onPageChange?.(null, page - 1);
        }}
        page={page}
        rowsPerPage={rowsPerPage}
        count={count}
        onPageChange={onPageChange}
        showFullPagination={false}
        // "Show all" toggles rowsPerPage between default and count
        // onShowAllClick={() => {
        //   if (showAllHref) return;
        //   const newSize = rowsPerPage === count ? 10 /* fallback default */ : count;
        //   // synthesize a native-like event for TablePagination
        //   onRowsPerPageChange?.({ target: { value: String(newSize) } });
        // }}
        disableNext={!canNext}
        disablePrev={!canPrev}
        // showAllHref={showAllHref}
        {...rest}
      />
    </>
  );
};

export default DataGridPaginationAction;
